<template>
  <div
    v-if="onVisible"
    :class="{'fadeInDown': onVisible === true, 'fadeOut': onVisible === false}"
    class="main-stick animated">
    <div
      :class="{ 'disabled': indexClient == 0 }"
      class="before"
      @click="beforeClient">
      <i class="icon-chevron-left"/>
    </div>
    <div class="content-stick">
      <div class="logo">
        <div class="circle">
          <p>{{ initialName | uppercase }}</p>
        </div>
      </div>
      <div class="name-item">
        <h5>{{ customerCurrent.firstName | uppercase }}&nbsp;{{ customerCurrent.lastName | uppercase }}</h5>
        <p>{{ customerCurrent.company | uppercase }}</p>
      </div>
      <div
        v-if="customerCurrent.favourite === true"
        class="item-favorite">
        <i class="icon-star"/>
      </div>
      <div class="email-item">
        <h6>Correo Eléctronico</h6>
        <p>{{ customerCurrent.email }}</p>
      </div>
      <div class="name-item">
        <h6>Teléfono</h6>
        <p>{{ customerCurrent.phone }}</p>
      </div>
      <div class="item-activity">
        <p>{{ customerCurrent.suburb }}</p>
      </div>
    </div>
    <div
      :class="{ 'disabled': indexClient == (customers.length - 1) }"
      class="after"
      @click="nextClient">
      <i class="icon-chevron-right"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerHeaderStick',
  props: {
    customerCurrent: {
      type: Object,
      default: null
    },
    onVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    initialName () {
      let letter1 = this.customerCurrent.firstName[0]
      let letter2 = this.customerCurrent.lastName[0]
      return letter1 + letter2
    },
    customers () {
      return this.$store.getters['customers/items']
    },
    indexClient () {
      let index = null
      for (let i = 0; i < this.customers.length; i++) {
        const element = this.customers[i]
        if (element.id === this.customerCurrent.id) {
          index = i
        }
      }
      return index
    }
  },
  methods: {
    nextClient () {
      let nextIndex = this.indexClient
      if (nextIndex < this.customers.length) {
        this.$router.push({ name: 'customers-info', params: { id: this.customers[nextIndex + 1].id } })
      }
    },
    beforeClient () {
      let beforeIndex = this.indexClient
      if (beforeIndex > 0) {
        this.$router.push({ name: 'customers-info', params: { id: this.customers[beforeIndex - 1].id } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-stick{
  height: 60px;
  top: 0px;
  left: 0px;
  position: absolute;
  z-index: 100;
  width: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid $border-primary;
  border-top: 1px solid $border-primary;
  display: flex;
  justify-content: space-between;
  .before, .after{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    color: #9D9D9D;
    &.disabled {
      color: rgba(#9D9D9D, 0.40);
      cursor: auto;
    }
  }
  .circle {
    background-color: #FFBD3A;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    p {
      color: #fff;
      margin: 0;
      font-size: 18px;
    }
  }
  .content-stick{
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex: 1;
    .logo{
      .el-button{
        width: 40px;
        height: 40px;
        background-color: $item-logo;
        color: #ffffff;
        border: none;
      }
    }
    .item-favorite{
      i{
        font-size: 16px;
      }
    }
    h6{
      margin: 0;
      @include font-lato(12px, bold)
    }
    h5{
      margin: 0;
      color: $items-primary;
      @include font-primary(16px, light)
    }
    p{
      margin: 0;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/customers/_shared/customers-header-stick.vue